import { offlineExchange } from '@urql/exchange-graphcache';

import schema from '../../../../graphql/introspection.json';
import type { GraphCacheConfig } from '../../../../graphql/types';
import type { OfflineStorage } from '../../storage';
import { keys } from './keys';
import { resolvers } from './resolvers';
import { updates } from './updates';

export type OfflineCacheExchange = ReturnType<typeof createCache>;

export const createCache = (storage: OfflineStorage) => {
  return offlineExchange<GraphCacheConfig>({
    // @ts-expect-error something with "kind" types
    schema,
    storage,
    keys,
    resolvers,
    updates,
  });
};
